<script>
import Move from "./Move.vue";
export default {
  name: 'ConfigureCircuit',
  props: ['circuit'],
  components: {
    Move,
  },
  data(){
    return {
        types: [
          { value: null, text: 'Please select an option' },
          { value: 'timer', text: 'Timer' },
          { value: 'reps', text: 'Reps' },],
        selectedType: '',
        work: '',
        rest: '',
    }
  },
  computed: {
      hasSelectedType(){
          return !!this.selectedType
      }
  },
  methods: {
      cancel(){
          this.$store.dispatch('scripts/removeCircuit', this.circuit.id)
      },
      confirm(){
          this.$store.dispatch('scripts/updateCircuit', {
              type: this.selectedType,
              work: this.work,
              id: this.circuit.id,
              rest: this.rest,
              confirmed: true
          })
      }
  }
};
</script>


<style scoped>
.circuit-list {
  margin: 0;
  padding: 0;
  position: relative;
}
.pointer{
  position: absolute;
  top: 200px;
  left: 450px;
}
.note{
  position: absolute;
  top: 120px;
  left: 350px;
  text-align: center;
}
.configure{
    background-color: #effdff;
    padding: 18px;
}
.configure label{
    text-transform: uppercase;
}
.configure .btn-action{
    text-transform: uppercase;
    margin-right: 0.5rem;
}
.configure .btn-container{
    display: flex;
    align-items: center;
}
.slash{
    display:flex;
    justify-content: center;
    align-items: flex-end;
    font-weight: 400;
    font-size: 1.75rem;
}
</style>

<template>
  <div class="circuit-list">
    <div class="row configure">
        <div class="col-md-6">
            <div class="row">
                <div class="col-md-4 offset-md-4">
                    <label>Circuit Type</label>
                    <b-form-select :options="types" v-model="selectedType"></b-form-select>
                </div>
                <div class="col-md-4" v-if="hasSelectedType && selectedType === 'timer'">
                    <div class="row no-gutters">
                        <div class="col-md-5">
                            <label>Work</label>
                            <b-form-input v-model="work" placeholder="Eg.: 60"></b-form-input>
                        </div>
                        <div class="col-md-2 slash">
                            <span>/</span>
                        </div>
                        <div class="col-md-5 rest-container">
                            <label>Rest</label>
                            <b-form-input v-model="rest" placeholder="Eg.: 20"></b-form-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row h-100">
                <div class="col-md-6 offset-md-6 btn-container">
                    <div>
                        <b-button size="sm" class="btn-action cancel" @click="cancel">Cancel</b-button>
                        <b-button size="sm" class="btn-action" variant="primary" :disabled="!hasSelectedType" @click="confirm">Confirm</b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <move></move><move></move><move></move><move></move><move></move
    ><move></move><move></move><move></move><move></move><move></move>
  </div>
</template>